module.exports = __webpack_public_path__ + "img/bg_institute.f4e726ac.jpg";